import {Grid, TableCell, TableRow, Typography} from "@material-ui/core";
import StatusCardWithoutIcon
    from "../../../../../../../../../../shared/components/status-card/status-card-without-icon/StatusCardWithoutIcon";
import EmptyRow from "../../../../../../../../../ui/tables/rows/empty-row/EmptyRow";
import {headCells} from "../TipologiaApnHelper";
import SimpleTable from "../../../../../../../../../../shared/components/tables/simple-table/SimpleTable";
import PropTypes from "prop-types";

const TipologiaApnSubtable = (props) => {
    const tableRows = (
        props.tableData && props.tableData.length > 0 ? props.tableData.map((row, index) => {
            return (
                <TableRow key={'apn-condiviso-table-id-' + index} hover>
                    <TableCell align='left'>
                        {row.nome ?
                            <Typography variant="subtitle2">{row.nome}</Typography>
                            :
                            <Grid container>
                                <StatusCardWithoutIcon
                                    color="blue"
                                    text="nome da definire"/>
                            </Grid>
                        }
                    </TableCell>
                    <TableCell align='left'>
                        <Typography variant={"subtitle2"}>{row.costoAttivazione}</Typography>
                    </TableCell>
                    <TableCell align='left'>
                        <Typography variant={"subtitle2"}>{row.costoUnitario}</Typography>
                    </TableCell>
                </TableRow>
            )
        }) : <EmptyRow text='dato' colSpan={headCells.length}/>
    )

    return (
        <>
            <Typography variant={"subtitle1"} className='ml-12'>{props.title}</Typography>
            <SimpleTable headCells={headCells} tableRows={tableRows} loading={props.loading}/>
        </>
    )
}

TipologiaApnSubtable.propTypes = {
    title: PropTypes.string.isRequired,
    tableData: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired
}

export default TipologiaApnSubtable;